import {generateRouteTo} from 'epic-fortnite-react';
import {connectToStores} from 'epic-alt-utils';
import PropTypes from 'prop-types';
import React from 'react';
import {Redirect, withRouter} from 'react-router';

import PaymentsActStore from '../../stores/PaymentsActStore';

/*eslint-disable jsx-a11y/anchor-is-valid */
/**
 * FAQ View
 */
@connectToStores
class PaymentsActView extends React.Component {
  static propTypes = {
    paymentsActStore: PropTypes.object,
    location: PropTypes.object,
  };

  static getStores() {
    return [PaymentsActStore];
  }

  static getPropsFromStores() {
    return {
      paymentsActStore: PaymentsActStore.getState(),
    };
  }

  render() {
    const {
      paymentsActStore: {
        fundsSettlementAct,
        commercialTransactions,
        fundsSettlementActTitle,
        commercialTransactionsTitle,
      },
      location,
    } = this.props;
    if (!fundsSettlementAct || !commercialTransactions) {
      return <Redirect to={generateRouteTo('/', location)} />;
    }
    return (
      <div className="paymentsact-view-container">
        <div className="light-bg">
          <div id="paymentsactContainer" className="container paymentsact">
            <div className="site-block paymentsact-container">
              <div className="site-block-header">
                <h1 className="site-block-title pull-left paymentsact-title">
                  {fundsSettlementActTitle}
                </h1>
                <div className="clearfix" />
              </div>
              <div className="site-block-body">
                <div
                  className="site-block-body-text paymentsact-text"
                  dangerouslySetInnerHTML={{__html: fundsSettlementAct}}
                />
              </div>
              <div className="site-block-header">
                <h1 className="site-block-title pull-left paymentsact-title">
                  {commercialTransactionsTitle}
                </h1>
                <div className="clearfix" />
              </div>
              <div className="site-block-body">
                <div
                  className="site-block-body-text paymentsact-text"
                  dangerouslySetInnerHTML={{__html: commercialTransactions}}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default withRouter(PaymentsActView);
